import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';

import { takeUntil } from 'rxjs';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { BackgroundFileService } from 'src/app/shared-new/services/background-file.service';
import { environment } from '../../../environments/environment';
import { SaleHorse } from '../../models/sales/sale-horse.model';
import { StudyFileUpload } from '../../models/Study/study-file.model';
import { Study } from '../../models/Study/study.model';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { FileUploaderBrodcastService } from '../../services/file-uploader-brodcast.service';
import { FileUploaderWorkerService } from '../../services/file-uploader-worker.service';
import { RouteParamsService } from '../../services/route-param.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { StudiesFacade } from '../../shared-new/store/studies/studies.facade';
import { EventsEmitter } from '../event-emitter/EventEmitter';

declare function getAllFiles(): [];
declare function backgroundSync(): void;
declare function getDateFromTicks(netTicks: any): void;
declare function getTotalFilesCountUploadingStarted(): number;
declare function storeLastChunkNumber(fileId: any, chunkNumber: any): void;
declare function deleteLastChunkNumber(
  fileId: any,
  studyInstanceUID: any,
  studyId: any
): Promise<any>;
declare function addFiles(files: any, callback: any): void;
declare function setFileError(fileId: number, error: string): void;
declare function setFilePauseState(fileId: number, isPause: boolean): void;
declare function getFileError(fileId: number): string;

@Component({
  selector: 'background-file-uploader',
  templateUrl: './background-file-uploader.component.html',
  styleUrls: ['./background-file-uploader.component.scss'],
})
export class BackgroundFileUploaderComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  public files: any[];
  public studies: Study[] = [];
  public baseUrl = environment.api2BaseUrl;
  public isResume: boolean = true;
  public lotOrHipText: string = 'HIP';
  public isLoader: boolean = false;
  public obtainedStudy: any[] = [];
  private studyId: any;
  private saleId: any;
  private horseId: any;
  public constructor(
    public readonly authService: AuthService,
    private readonly router: Router,
    private readonly activeRoute: ActivatedRoute,
    private modalService: NgbModal,
    private readonly eventEmitter: EventsEmitter,
    private readonly studyFacade: StudiesFacade,
    private readonly commonService: CommonService,
    private readonly cdr: ChangeDetectorRef,
    private fileUploaderWorkerService: FileUploaderWorkerService,
    private fileUploaderBrodcastService: FileUploaderBrodcastService,
    private toastService: ToastService,
    private routeParamsService: RouteParamsService,
    private spinnerService: NgxSpinnerService,
    private backgroundFileService: BackgroundFileService
  ) {
    super();
    this.authService.getMemberLotOrHipText().subscribe((data) => {
      this.lotOrHipText = data;
    });
  }

  public ngOnInit(): void {
    this.attachEvents();
    const that = this;
    (async () => {
      const allFiles = await getAllFiles();
      that.files = allFiles;
      //appendFiles(allFiles)
      const fileInfos = allFiles.map((file: any) => {
        const fileInfo = localStorage.getItem(`${file.id}_fileInfo`);
        let chunkNumber: string = '0';
        if (fileInfo) {
          chunkNumber = JSON.parse(fileInfo).lastChunkNumber;
        }
        const chunkSize = 1024 * 1024; // 1MB chunk size (adjust as needed)
        const totalChunks = Math.ceil(file.file.size / chunkSize);
        return {
          fileId: file.id,
          chunk: chunkNumber,
          totalChunks: totalChunks,
        };
      });

      that.fileUploaderBrodcastService.postMessage({ action: 'stopped' });
    })();
  }

  public getDateFromNetTicks(netTicks: any) {
    const date = getDateFromTicks(netTicks);
    return date;
  }

  public attachEvents() {

    this.eventEmitter.fileUploadCompleteEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.studyFacade.onCompleteBatch(response);
      });
    const that = this;
    this.routeParamsService.currentParam$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((param) => {
        if (typeof param === 'object' && param !== null) {
          // If param is an object, bind saleId and horseId
          this.saleId = param.saleId;
          this.horseId = param.horseId;
        } else {
          // Otherwise, treat param as the studyId
          this.studyId = param;
        }
      });

    this.fileUploaderBrodcastService.registerWorkerMessageListener(
      (data: any) => {
        that.onProgress(data);
      },
      (data: any) => {
        that.onUploadStarted(data);
      },
      (data: any) => {
        that.onDeleteFileForOthers(data);
      },
      (data: any) => {
        that.onStopped(data);
      },
      (data: any) => {
        that.onCompleteUpload(true, data);
      }
    );

    this.fileUploaderWorkerService.registerServiceWorker();
    this.eventEmitter.fileStartUploadEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (response) => {
          this.backgroundFileService.addFilesUploading();
          this.spinnerService.show();
          await this.startUpload(response);
          this.cdr.detectChanges();
      });
    this.fileUploaderWorkerService.registerWorkerMessageListener(
      (message: any) => {
        that.onSaveFileChunk(message);
      },
      (message: any) => {
        that.onDeleteFile(message);
      },
      (message: any) => {
        that.onCustomErrors(message);
      },
      (message: any) => {
        that.onCheckConnectivity(message);
      },
      (message: any) => {
        that.onPauseFile(message);
      },
      () => { }
    );
    //this.fileUploaderWorkerService.registerServiceWorkerListener(() => { that.continueUploading() });
  }

  //** BrodcastChannel Events */
  private onProgress(data: any) {
    const fileInfo = data.fileInfo;
    this.showFileProgress(fileInfo);
    this.isResume = false;
    this.cdr.detectChanges();
  }

  private onUploadStarted(data: any) {
    this.files = data.allFiles;
    this.isResume = false;
    this.cdr.detectChanges();
  }

  private onDeleteFileForOthers(data: any) {
    this.removeFile(data.fileId);
    this.cdr.detectChanges();
  }

  private onStopped(data: any) {
    this.isResume = true;
    this.cdr.detectChanges();
  }

  //** Web Worker Events */
  private onCompleteUpload(isBrodcast: boolean, data: any) {
    if (!isBrodcast) {
      this.fileUploaderBrodcastService.postMessage({
        action: 'on-complete-upload',
      });
    }
    let horseId = data.studyFile?.horseId ? data.studyFile.horseId : data.horseId;
    let saleId = data.studyFile?.saleId ? data.studyFile.saleId : data.studyId;
    let saleHorseId = data.studyFile?.saleHorseId;
    let studyId = data.studyFile?.studyId ? data.studyFile.studyId : data.studyId;
    
    const model = {
      batchId: `${data.batchId}`,
      fileId: data.fileId,
      horseId: horseId,
      saleId: saleId,
      studyId: studyId,
      saleHorseId: saleHorseId
    }
    this.eventEmitter.emitFileUploadCompleteEvent(model);
  }
  private onSaveFileChunk(message: any) {
    storeLastChunkNumber(message.data.fileId, message.data.chunkNumber);

    // broadcast progress for other tabs
    const percentage = this.calculatePercentage(
      message.data.totalChunks,
      message.data.chunkNumber
    );
    const fileInfo = { fileId: message.data.fileId, progress: percentage };
    this.fileUploaderBrodcastService.postMessage({
      action: 'progress',
      fileInfo: fileInfo,
    });
    this.showFileProgress(fileInfo);
    this.isResume = false;
  }

  getComponentName() {
    const currentRoute = this.router.routerState.snapshot.root;
    const routeConfig = this.getDeepestRoute(currentRoute);
    return routeConfig.component?.name;
  }

  getDeepestRoute(route: ActivatedRouteSnapshot) {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.routeConfig;
  }
  private async onDeleteFile(message: any) {
    deleteLastChunkNumber(
      message.data.fileId,
      message.data.batchId,
      message.data.obtainedStudyId
    ).then(async () => {
      // broadcast event for other tabs to remove the file
      this.fileUploaderBrodcastService.postMessage({
        action: 'delete',
        fileId: message.data.fileId,
      });
      this.removeFile(message.data.fileId);
      const files: any[] = (await getAllFiles()) as any[];

      this.files = files;
      let studies: any[] = [];

      if (message.data.obtainedStudyId && message.data.obtainedStudyId > 0) {
        this.obtainedStudy.push(message.data.obtainedStudyId);
        studies = files.filter(
          (x) => x.studyId == message.data.obtainedStudyId
        );
      } else if (message.data.studyId > 0) {
        studies = files.filter((x) => x.studyId == message.data.studyId);
      } else {
        studies = files;
      }

      if (
        studies.length === 0 &&
        this.obtainedStudy.length > 0 &&
        this.obtainedStudy.includes(message.data.studyId)
      ) {
        this.onStudyFilesCompletedOfNewCreatedStudy(message.data.studyFile);
      }
      if (studies.length === 0) {
        this.onStudyFilesCompleted(message);
        this.backgroundFileService.removeFilesUploading();
      }
      // As per jack disscussion don't create multiple studies on the basis of studyInstanceUID

      //if (message.data.obtainedStudyId && message.data.studyInstanceUID) {
      //  this.files = files.filter(x => x.studyInstanceUID == message.data.studyInstanceUID);
      //} else {
      //  this.files = files;
      //}
      const isBatchAlreadyInProgress = getTotalFilesCountUploadingStarted() > 0;

      if (isBatchAlreadyInProgress) {
        this.backgroundFileService.addFilesUploading();
      }
      let batchFiles = [
        ...files.filter((x) => x.batchId == message.data.batchId),
      ];

      if (batchFiles.length === 0 && !isBatchAlreadyInProgress) {
        this.onCompleteUpload(false, message.data);
      }

      if (batchFiles.length == 0 && files.length > 0) {
        const nextBatchId = files[0].batchId;
        batchFiles = [...files.filter((x) => x.batchId == nextBatchId)];
        if (batchFiles.length > 0 && !isBatchAlreadyInProgress) {
          this.processBatch(batchFiles);
        }
      } else if (batchFiles.length > 0) {
        this.startUploading(batchFiles);
      }
    });
  }
  private onStudyFilesCompleted(message: any) {
    const saleHorse = {
      saleId: message.data.saleId,
      horseId: message.data.horseId,
    } as SaleHorse;
    const component = this.getComponentName();
    const isStudyDetailComponent =
      component == 'EditClinicalStudyProfileComponent';


    if (isStudyDetailComponent && this.studyId && this.studyId == message.data.studyId && (!saleHorse.saleId)) { // it only execute on study profile page
      //this.studyFacade.resetData();
      this.studyFacade.loadStudyById(message.data.studyId);
      this.studyFacade.loadStudyFilesByStudyId(message.data.studyId);
    }
    if (
      this.saleId == saleHorse.saleId &&
      this.horseId == saleHorse.horseId
    ) {
      //this.studyFacade.resetData();
      this.studyFacade.getSaleHorseStudies(saleHorse.saleId, saleHorse.horseId);
    }
  }
  private onStudyFilesCompletedOfNewCreatedStudy(studyFile: any) {
    const index = this.obtainedStudy.indexOf(studyFile.studyId);
    if (index !== -1) {
      this.obtainedStudy.splice(index, 1);
    }
    const filteredStudies = this.studies.filter(
      (x) => x.studyId == studyFile.studyId
    );
    if (filteredStudies.length === 0) {
      const study: Study = {
        studyId: studyFile.studyId,
        patientName: studyFile.patientName,
        studyDateTime: studyFile.studyDateTime,
        createdDate: studyFile.createdDate,
      } as Study;
      if (study.patientName && study.studyId) {
        this.studies.push(study);
      }
    }
    //console.log(this.studies);
  }

  private async onCustomErrors(message: any) {
    this.showFileError(message.data?.fileId, message.data?.error);
    const files: any[] = await getAllFiles();
    if (message.data.isSingleFile) {
      files.forEach((item) => {
        deleteLastChunkNumber(item.id, null, null).then(() => {
          this.fileUploaderBrodcastService.postMessage({
            action: 'delete',
            fileId: item.id,
          });
          this.removeFile(item.id);
        });
      });
      this.toastService.error(
        'Unable to create study, DICOM file seems to be corrupt. Please check and re-upload.',
        'Error', { delay: null }
      );
    } else {
      this.files = files;
      this.startUploading(files);
    }
  }

  private onCheckConnectivity(message: any) {
    backgroundSync();
  }

  private onPauseFile(message: any) {
    this.updateResumeIcon(message.data?.fileId);
  }
  public NavigateToStudy(studyId: number) {
    window.open(`clinic-studies/profile/${studyId}`);
  }
  public closeStudies() {
    this.studies = [];
  }
  public calculatePercentage(totalChunks: number, uploadedChunkNumber: number) {
    if (totalChunks === 0) {
      return 0; // Prevent division by zero
    }
    return Math.round((uploadedChunkNumber / totalChunks) * 100);
  }
  public updateResumeIcon(fileId: any) {
    this.files = this.files?.map((obj) => {
      if (obj.id === fileId) {
        return { ...obj, isPause: true }; // Update the name property if the ID matches
      } else {
        return obj;
      }
    });
  }
  public showFileProgress(fileInfo: any) {
    this.files = this.files?.map((obj) => {
      if (obj.id === fileInfo.fileId) {
        return { ...obj, progress: fileInfo.progress, isPause: false }; // Update the name property if the ID matches
      } else {
        return {
          ...obj,
          progress: obj.hasOwnProperty('progress') ? obj.progress : 0,
        };
      }
    });
  }
  public showFileError(fileId: number, errorData: any) {
    let errorMessage = '';
    if (errorData?.length > 0) {
      errorMessage = errorData[0].message;
    }

    if (errorMessage) {
      setFileError(fileId, errorMessage);
    }
    this.files = this.files?.map((obj) => {
      if (obj.id === fileId) {
        const error = getFileError(fileId);
        return { ...obj, error: error }; // Update the name property if the ID matches
      } else {
        return obj;
      }
    });
  }

  public removeFile(fileId: any) {
    this.files = this.files.filter((obj) => obj.id !== fileId);
  }
  public async removeChunkFile(file: any) {
    //this.spinnerService.show()
    file.disableDelete = true;
    this.commonService
      .cancelFileUploading(file.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (response) => {
        const saleHorse = {
          saleId: file.saleId,
          horseId: file.horseId,
        } as SaleHorse;
        if (!this.studyId) {

          //this.studyFacade.resetData();
          this.studyFacade.getSaleHorseStudies(
            saleHorse.saleId,
            saleHorse.horseId
          );

        }

        deleteLastChunkNumber(file.id, null, null).then(async () => {
          // broadcast event for other tabs to remove the file
          this.fileUploaderBrodcastService.postMessage({
            action: 'delete',
            fileId: file.id,
          });
          this.removeFile(file.id);
          const inProgressFilesForFetchingStudy = this.files.filter(
            (x) =>
              x.disablePause == true &&
              x.disablePlay == true &&
              x.disableDelete == true
          );
          const inProgressFileIds = inProgressFilesForFetchingStudy.map(
            (file) => file.id
          );
          const files = (await getAllFiles()) as any[];
          this.files = files;
          this.files = this.files.map((file) => {
            if (inProgressFileIds.includes(file.id)) {
              file.disablePause = true;
              file.disablePlay = true;
              file.disableDelete = true;
            }
            return file;
          });
          // this.spinnerService.hide()
        });
      });
  }

  public pauseChunkFile(file: any): void {
    //this.spinnerService.show()
    file.isPause = true;
    file.disablePlay = false;
    file.disablePause = true;
    setFilePauseState(file.id, true);
    this.commonService
      .pauseFileUploading(file.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        //this.spinnerService.hide()
        file.disablePause = false;
      });
  }

  public async resumeChunkFile(file: any) {
    //this.spinnerService.show()
    file.disablePlay = true;
    file.disablePause = false;
    setFilePauseState(file.id, false);
    const files: any[] = ((await getAllFiles()) as any[]).filter(
      (x) => x.batchId == file.batchId
    );
    const isStudyAssignToBatch = files.some((x) => x.studyId);
    const isSaleAssignToBatch = files.some((x) => x.saleId);
    const isHorseAssignToBatch = files.some((x) => x.horseId);
    const totalStartedItems = getTotalFilesCountUploadingStarted();
    this.commonService
      .resumeFileUploading(file.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        file.isPause = false;
        file.disablePlay = false;
        //this.spinnerService.hide()
        const token = this.authService.getToken();
        //if (!isStudyAssignToBatch) {
        //  const dbFile = files.filter(x => x.id == file.id);
        //  this.startUploadingWithSingleFileModel(dbFile);
        if (
          (isSaleAssignToBatch ||
            isHorseAssignToBatch ||
            isStudyAssignToBatch) &&
          totalStartedItems <= 4
        ) {
          const dbFile = files.filter((x) => x.id == file.id);
          this.fileUploaderWorkerService.postMessage({
            dbFiles: dbFile,
            url: this.baseUrl,
            token: token,
          });
        }
      });
  }
  public groupBy(array: any[], key: string) {
    return array.reduce((result, currentValue) => {
      // Get the value of the key we want to group by
      const groupKey = currentValue[key];

      // If the group doesn't exist yet, create it
      if (!result[groupKey]) {
        result[groupKey] = [];
      }

      // Push the current value to the group
      result[groupKey].push(currentValue);

      return result;
    }, {});
  }
  public isDicomFile(fileName: string): boolean {
    const dicomExtensions = ['dcm', 'dicom'];
    const extension = fileName.split('.').pop().toLowerCase();
    return dicomExtensions.includes(extension);
  }
  public async startUpload(files: StudyFileUpload[]) {
    if (files.length == 0) {
      console.error('No file selected.');
      return;
    }
    const isBatchAlreadyInProgress = getTotalFilesCountUploadingStarted() > 0;
    addFiles(files, async (allFiles: any[]) => {
      this.eventEmitter.emitFileUploadDataSavedEvent();
      this.files = allFiles;
      this.spinnerService.hide();
      if (!isBatchAlreadyInProgress) {
        this.processBatch(allFiles);
      }
    });
  }
  private processBatch(batchFiles: any[]) {
    if (batchFiles.length == 0) {
      console.error('No file selected.');
      return;
    }
    const filesWithoutHorse = batchFiles.filter((x) => !x.saleId && !x.horseId);
    const filesWithStudy = batchFiles.filter((x) => x.studyId);

    if (filesWithStudy.length > 0) {
      this.startUploading(batchFiles);
    } else if (filesWithoutHorse.length > 0) {
      const dicomFileOfBatch = batchFiles.filter((x) =>
        this.isDicomFile(x.file.name)
      );
      if (dicomFileOfBatch.length > 0) {
        // This is due to remove the grouping on study instance uid to prevent creating multiple studies
        //const file = dicomFileOfBatch[0];
        // const uiFile = this.files.filter(x => x.id = dicomFileOfBatch[0].id)[0];
        this.files = this.files.map((file) => {
          if (file.id == dicomFileOfBatch[0].id) {
            file.disablePause = true;
            file.disablePlay = true;
            file.disableDelete = true;
          }
          return file;
        });
        //uiFile.disablePause = true;
        //uiFile.disablePlay = true;

        this.startUploadingWithSingleFileModel([dicomFileOfBatch[0]]);
      }
    } else {
      this.startUploadingWithSingleFileModel([batchFiles[0]]);
    }
  }
  public startUploadingWithSingleFileModel(allFiles: any[]) {
    allFiles = allFiles.filter((x) => x.isPause == false);
    const token = this.authService.getToken();
    this.fileUploaderWorkerService.postMessage({
      dbFiles: allFiles,
      url: this.baseUrl,
      token: token,
      isSingleFile: true,
    });
    this.fileUploaderBrodcastService.postMessage({
      action: 'upload-started',
      allFiles: allFiles,
    });
  }
  public startUploading(allFiles: any[]) {
    allFiles = allFiles.filter((x) => x.isPause == false);
    const totalStartedItems = getTotalFilesCountUploadingStarted();
    if (totalStartedItems <= 4) {
      const notStartedItems = allFiles
        .filter((x) => !x.lastChunkNumber && !x.error)
        .slice(0, 4 - totalStartedItems);
      //const startedItems = allFiles.filter(x => x.lastChunkNumber > 0).slice(0, 4 - notStartedItems.length);
      //const filesToUpload = startedItems.concat(notStartedItems);
      const token = this.authService.getToken();
      this.fileUploaderWorkerService.postMessage({
        dbFiles: notStartedItems,
        url: this.baseUrl,
        token: token,
        isSingleFile: false,
      });
    }
    //this.files = allFiles;
    //broadcast file upload started event for other tabs
    this.fileUploaderBrodcastService.postMessage({
      action: 'upload-started',
      allFiles: allFiles,
    });
  }

  //public async continueUploading() {
  //  let allFiles = (await getAllFiles() as any[]);
  //  allFiles = allFiles.filter(x => x.isPause == false);
  //  this.files = allFiles;
  //  const totalStartedItems = getTotalFilesCountUploadingStarted();
  //  if (totalStartedItems <= 4) {
  //    const notStartedItems = (allFiles as any[]).filter(x => !x.lastChunkNumber && !x.error).slice(0, 4 - totalStartedItems);
  //    const startedItems = (allFiles as any[]).filter(x => x.lastChunkNumber > 0 && !x.error).slice(0, 4 - notStartedItems.length);
  //    //const filesToUpload = startedItems.concat(notStartedItems);
  //    const token = this.authService.getToken();
  //    if (startedItems.length > 0) {
  //      this.fileUploaderWorkerService.postMessage({ dbFiles: startedItems, url: this.baseUrl, token: token, isSingleFile: false });
  //    } else {
  //      this.fileUploaderWorkerService.postMessage({ dbFiles: notStartedItems, url: this.baseUrl, token: token, isSingleFile: false });
  //    }
  //  }
  //  //broadcast file upload started event for other tabs
  //  this.fileUploaderBrodcastService.postMessage({ "action": "upload-started", allFiles: allFiles });

  //}

  public hasAllFilesErrors(): boolean {
    const totalFilesLength = this.files.length;
    const errorFilesLenght = this.files.filter((x) => x.error).length;
    const hasAllFilesErrors = totalFilesLength === errorFilesLenght;
    return hasAllFilesErrors;
  }
}
